module.exports = __webpack_public_path__ + "img/icon01.50cbef07.png";